import Big from 'big.js';

export const maxBig = (array: Big[]): Big | undefined =>
  array.reduce((max, current) => (current.gt(max) ? current : max), array[0]);
